import { render, staticRenderFns } from "./WhatsappLink.vue?vue&type=template&id=17c107e7&scoped=true&"
import script from "./WhatsappLink.vue?vue&type=script&lang=js&"
export * from "./WhatsappLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c107e7",
  null
  
)

export default component.exports